export default __webpack_public_path__ + "static/aiPageBackground2-e860f342b6e4b7ae887cb4412b5c07bd.webp";